import { cn } from '#lib/utils'

interface UserIconProps {
  firstName?: string
  lastName?: string
  className?: string
}

export function UserIcon({ firstName, lastName, className }: UserIconProps) {
  const initials = `${firstName?.[0].toUpperCase() ?? ''}${lastName?.[0]?.toUpperCase() ?? ''}`
  return (
    <div
      className={cn(
        'flex size-10 shrink-0 items-center justify-center rounded-full bg-yellow-300 text-base font-semibold text-gray-950 hover:bg-yellow-300',
        className
      )}
    >
      {initials}
    </div>
  )
}
